import React, { useEffect } from 'react';
import { useThree } from '@react-three/fiber';
import { Color } from 'three';

/**
 * Setzt den Scene-Hintergrund unabhängig vom Environment
 * Stellt sicher, dass die Scene immer einen sichtbaren Hintergrund hat
 */
const SceneBackground = ({ color }) => {
  const { scene } = useThree();

  useEffect(() => {
    if (color) {
      // Setze Hintergrund sofort
      scene.background = new Color(color);
    }
  }, [scene, color]);

  return null;
};

export default SceneBackground;

